'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'truck-fast';
var width = 640;
var height = 512;
var aliases = ["shipping-fast"];
var unicode = 'f48b';
var svgPathData = 'M128 80l288 0c8.8 0 16 7.2 16 16l0 260.1c-13.6 11.2-23.8 26.5-28.7 43.9l-102.6 0c-10.4-36.9-44.4-64-84.7-64s-74.2 27.1-84.7 64l-3.3 0c-8.8 0-16-7.2-16-16l0-80 24 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L24 256c-13.3 0-24 10.7-24 24s10.7 24 24 24l40 0 0 80c0 35.3 28.7 64 64 64l3.3 0c10.4 36.9 44.4 64 84.7 64s74.2-27.1 84.7-64l102.6 0c10.4 36.9 44.4 64 84.7 64s74.2-27.1 84.7-64l3.3 0c35.3 0 64-28.7 64-64l0-151.4c0-17-6.7-33.3-18.7-45.3l-40.6-40.6c-12-12-28.3-18.7-45.3-18.7l-55.4 0 0-32c0-35.3-28.7-64-64-64L128 32C92.7 32 64 60.7 64 96l0 16 48 0 0-16c0-8.8 7.2-16 16-16zM480 256l0-80 55.4 0c4.2 0 8.3 1.7 11.3 4.7l40.6 40.6c3 3 4.7 7.1 4.7 11.3l0 23.4-112 0zm0 48l112 0 0 80c0 8.8-7.2 16-16 16l-3.3 0c-10.4-36.9-44.4-64-84.7-64-2.7 0-5.4 .1-8 .4l0-32.4zM64 160l-40 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L64 160zM216 384a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm272 0a40 40 0 1 1 0 80 40 40 0 1 1 0-80z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTruckFast = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;